module.exports = {
      id: "7ce5eab487e237b18c948fe4a20d4ab6bathroomEquipment-classic-bathtub.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#7ce5eab487e237b18c948fe4a20d4ab6bathroomEquipment-classic-bathtub.svg",
      toString: function () {
        return this.url;
      }
    }